import * as React from "react";
import { useAppSelector, useAppDispatch } from "../store/index";
import { RootState } from "../reducers/index";
import { PoiSearch } from "../api/poisearch";
import { IMapOptions } from "../interfaces/mapoptions";
import HalfwayPoiLink from "./halfwaypoilink";

function formatMiles(totalmiles: number): string {
    if (totalmiles < 10) {
        return totalmiles.toFixed(1);
    }
    else {
        return totalmiles.toFixed(0);
    }
}

const HalfwayData = () => {
    const poiList = useAppSelector<Array<PoiSearch>>((x: RootState) => x.poi.list);
    const locationNameLong = useAppSelector<string>((x: RootState) => x.halfway.locationNameLong);
    const totalDistance = useAppSelector<number>((x: RootState) => x.halfway.totalDistance);
    const mapoptions = useAppSelector<IMapOptions>((x: RootState) => x.mapoptions);

    if (!locationNameLong) {
        return null;
    }

    const halfwayAddress = (<span>{locationNameLong}</span>);

    const totalmiles = totalDistance * 0.000621371192237;
    const miles = formatMiles(totalmiles);

    let pois: JSX.Element = null;
    if (poiList.length >= 3) {
        pois = <React.Fragment>Some places you could meet at include <HalfwayPoiLink result={poiList[0].result} />, <HalfwayPoiLink result={poiList[1].result} />,
            and <HalfwayPoiLink result={poiList[2].result} />.</React.Fragment>;
    }

    return (
        <div className="mid-data">
            These locations are <span>{miles} miles</span> apart and the exact midpoint is {halfwayAddress}.
            You searched for <span>{mapoptions.poi}</span>. {pois}
        </div>);
};

export default HalfwayData;
